import React from 'react'
import { Col, Container, Row, Table } from "reactstrap";
import { TabletExternalDocumentation } from './TabletExternalDocumentation';

export function GdExternalDocumentation() {
  return (
     <Container className="dashboard">
      <Row>
        <Col md={12}>
            <h3 style={{ marginBottom: 30, color:"#024b82" }}>Radicación</h3>
        </Col>
      </Row>
      <Row>
        <TabletExternalDocumentation />
      </Row>
    </Container>
  )
}
